import { LancamentoPrincipal } from "../lancamento-principal";

export const TARIFAS_BANCO = {
   itau: [
    "REND PAGO APLIC AUT MAIS",
    "TAR COBRANCA MENSAL",
    "TAR PIX PGTO TRANSF",
    "TAR/CUSTAS COBRANCA",
    "TTAR CHEQUE EMITIDO",
    "TAR TED 012500",
    "TAR CHEQUE EMITIDO"
   ],
   bradesco: [
      "RENTAB.INVEST FACILCRED*",
      "CARTAO CREDITO ANUIDADE",
      "DOC/TED INTERNET TED INTERNET"
   ]
};

export const isTarifaItau = (l: LancamentoPrincipal) => l.descricao != null && TARIFAS_BANCO.itau.includes(l.descricao);
export const isTarifaBradesco = (l: LancamentoPrincipal) => l.descricao != null && TARIFAS_BANCO.bradesco.includes(l.descricao);